var App = {
  Validation : {},
  Views      : {},
  Models     : {},
  Collections: {},
  Templates  : {},
  Inits      : {}
};

module.exports = App;



// WEBPACK FOOTER //
// ./namespace.js